import React, { useRef, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
	ListItemIcon,
	ListItemText,
	Tooltip,
	IconButton,
	Menu,
	MenuItem,
} from '@mui/material';
import { MoreVert, Sync } from '@mui/icons-material';

const useStyles = makeStyles(() => ({}));

const ActionsButton = (props) => {
	const { syncTracker } = props;
	const classes = useStyles();
	const moreRef = useRef(null);
	const [openMenu, setOpenMenu] = useState(false);

	const handleMenuOpen = () => {
		setOpenMenu(true);
	};

	const handleMenuClose = () => {
		setOpenMenu(false);
	};

	const _syncTracker = () => {
		setOpenMenu(false);
		syncTracker();
	};

	return (
		<>
			<Tooltip title="More options">
				<IconButton
					{...props}
					onClick={handleMenuOpen}
					ref={moreRef}
					size="small"
				>
					<MoreVert />
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={moreRef.current}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				classes={{ paper: classes.menu }}
				onClose={handleMenuClose}
				open={openMenu}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<MenuItem onClick={_syncTracker}>
					<ListItemIcon>
						<Sync />
					</ListItemIcon>
					<ListItemText primary="Sync Tracker" />
				</MenuItem>
			</Menu>
		</>
	);
};

ActionsButton.propTypes = {
	className: PropTypes.string,
	syncTracker: PropTypes.func,
};

export default memo(ActionsButton);
